// import React, { useState } from "react";

// function ApplyForIDO() {
//   return (
//     <>
//       <div style={{ backgroundColor: "#fff", height: "100vh" }}>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             marginBottom: "2.5rem",
//             marginTop: "3.5rem",
//           }}
//         >
//           <h3
//             style={{
//               // display: "flex",
//               color: "#000",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             InfinityPad: Token Sale Application
//           </h3>
//           <h6 style={{ color: "#e1673d" }}>
//             Fields marked (&#42;) are required{" "}
//           </h6>
//         </div>
//         <form
//           style={{
//             backgroundColor: "#fff",
//             display: "flex",
//             flexDirection: "column",
//             // justifyContent: "spaceBetween",
//             alignItems: "center",
//           }}
//         >
//           <div
//             style={{
//               border: "3px solid #c0c0c045",
//               boxShadow: "#68656521 0px 0px",
//               borderRadius: "10px",
//               height: "100vh",
//               width: "45%",
//               alignItems: "center",
//               // justifyContent: "center",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <div>
//               <label>Name (Person Of Contact):</label>
//               <input
//                 type="text"
//                 placeholder="Your Name"
//                 id="name"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Email (Person Of Contact):</label>
//               <input
//                 type="email"
//                 placeholder="xyz@example.com"
//                 id="name"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Token Name:</label>
//               <input
//                 type="text"
//                 placeholder="Binance"
//                 id="name"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//               <label>Token Symbol:</label>
//               <input
//                 type="text"
//                 placeholder="BNC"
//                 id="symbol"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Presale Rate:</label>
//               <input
//                 type="number"
//                 placeholder="15"
//                 id="presale_rate"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             {/* <div>
//             <label>Softcap:</label>
//             <input type="number" placeholder="5" id="softcap" style={{ border: "solid 2px", borderRadius: "3px" }}/>
//             <label>Hardcap:</label>
//             <input type="number" placeholder="10" id="hardcap" style={{ border: "solid 2px", borderRadius: "3px" }}/>
//           </div> */}
//             <div>
//               <label>Minimum Buy (in BNB):</label>
//               <input
//                 type="number"
//                 placeholder="0.01 BNB"
//                 id="minibuy"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//               <label>Maximum Buy (in BNB):</label>
//               <input
//                 type="number"
//                 placeholder="1 BNB"
//                 id="maxibuy"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>IDO Start Date:</label>
//               <input
//                 type="date"
//                 id="start_date"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//               <label>IDO End Date:</label>
//               <input
//                 type="date"
//                 id="end_date"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <h4>Fundraising State:</h4>
//               <div>
//                 <checkbox
//                   // type="checkbox"
//                   id="no_fund"
//                   style={{ border: "solid 2px", borderRadius: "3px" }}
//                 />
//                 <label>Haven't raised any fund to date</label>
//               </div>
//               <div>
//                 <input
//                   type="checkbox"
//                   id="private_sale"
//                   style={{ border: "solid 2px", borderRadius: "3px" }}
//                 />
//                 <label>Private sale round</label>
//               </div>
//               <div>
//                 <input
//                   type="checkbox"
//                   id="presale_round"
//                   style={{ border: "solid 2px", borderRadius: "3px" }}
//                 />
//                 <label>Presale round</label>
//               </div>
//               <div>
//                 <input
//                   type="checkbox"
//                   id="public_sale"
//                   style={{ border: "solid 2px", borderRadius: "3px" }}
//                 />
//                 <label>Public sale round</label>
//               </div>
//             </div>
//             <div>
//               <label>Fund Raised (in BNB):</label>
//               <input
//                 type="number"
//                 placeholder="5 BNB"
//                 id="website"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Logo Link:</label>
//               <input
//                 type="url"
//                 placeholder="https://samurai.cyberfi.tech/_nuxt/img/star.b781d0c.svg"
//                 id="logo"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>

//             <div>
//               <label>Website Link:</label>
//               <input
//                 type="url"
//                 placeholder="https://infinitypad.com/"
//                 id="website"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Facebook:</label>
//               <input
//                 type="url"
//                 placeholder="https://facebook.com/"
//                 id="facebook"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Twitter:</label>
//               <input
//                 type="url"
//                 placeholder="eg: https://twitter.com/"
//                 id="twitter"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Whitepaper Link:</label>
//               <input
//                 type="url"
//                 placeholder="eg: https://google.drive/whitepaper/"
//                 id="white_paper"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>Short Description:</label>
//               <input
//                 type="textarea"
//                 placeholder="One paragraph summary about your IDO"
//                 id="description"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <label>About IDO:</label>
//               <input
//                 type="textarea"
//                 placeholder="Binance"
//                 id="about"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               />
//             </div>
//             <div>
//               <button
//                 placeholder="Binance"
//                 // name="Apply"
//                 id="about"
//                 style={{ border: "solid 2px", borderRadius: "3px" }}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </form>

//       </div>
//     </>
//   );
// }

// export default ApplyForIDO;

import React from "react";

function ApplyForIDO() {
  return (
    <>
      <div style={{ backgroundColor: "#fff", height: "100vh " }}>
        <div
          style={{
            margin: "0 auto",
            maxWidth: "800px",
            marginTop: "50px",
            backgroundColor: "#fff",
          }}
        >
          <div style={{ marginBottom: "35px" }}>
            <h3
              style={{
                color: "#000",
              }}
            >
              InfinityPad: Token Sale Application
            </h3>
            <h6 style={{ color: "#e1673d" }}>
              Fields marked (&#42;) are required{" "}
            </h6>
          </div>
          <form>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="inputname4">Name (Person of Conta):</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputname4"
                  placeholder="Your Name"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="inputEmail4">Email (Person of Contact):</label>
                <input
                  type="email"
                  class="form-control"
                  id="inputEmail4"
                  placeholder="xyz@example.com"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="inputAddress">
                Token Name:
                {/* <p style={{ color: "#e1673d" }}>&#42;</p> */}
              </label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Binance"
              />
            </div>
            <div class="form-group">
              <label for="inputAddress2">Symbol</label>
              <input
                type="text"
                class="form-control"
                id="inputAddress2"
                placeholder="BNB"
              />
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="inputPresale">Presale Rate (in BNB)</label>
                <input
                  type="number"
                  class="form-control"
                  id="inputPresale"
                  min={0}
                  step="0.0001"
                  placeholder="5 BNB"
                />
              </div>
              {/* <div class="form-group col-md-4">
              <label for="inputState">State</label>
              <select id="inputState" class="form-control">
                <option selected>Choose...</option>
                <option>...</option>
              </select>
            </div> */}
            </div>
            <div class="form-group">
              <h6>Fundraising State:</h6>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  Check me out
                </label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  Check me out
                </label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  Check me out
                </label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  Check me out
                </label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  Check me out
                </label>
              </div>
            </div>
            <button type="submit" class="btn btn-primary">
              Sign in
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ApplyForIDO;
